const globalStyles = {};
export default globalStyles;

